import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMPassword from "src/components/UI/atoms/formFields/ATMPassword/ATMPassword";

export type ChangeAdminPasswordValues={
    newPassword:string ;
    confirmPassword:string
}

type Props = {
  formikProps: FormikProps<ChangeAdminPasswordValues>;
  onClose: () => void;
  formType?: "ADD" | "EDIT";
};

const ChangePasswordDialogForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Change Password</div>
        <button
          type="button"
          className="hover:bg-hover p-2 rounded"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
   
        {/* New Password */}
        <div>
          <ATMPassword
            name="newPassword"
            value={values?.newPassword}
            onChange={(e) => setFieldValue("newPassword", e.target.value)}
            label="New password"
            placeholder="Enter new password"
            onBlur={handleBlur}
          />
        </div>

             {/* Confirm  passwordd */}
             <div>
          <ATMPassword
            name="confirmPassword"
            value={values?.confirmPassword}
            onChange={(e) => setFieldValue("confirmPassword", e.target.value)}
            label="Confirm  password"
            placeholder="Enter confirm password"
            onBlur={handleBlur}
          />
        </div>

      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ChangePasswordDialogForm;
